import { render, staticRenderFns } from "./Marzipano.vue?vue&type=template&id=46d649da&scoped=true"
import script from "./Marzipano.vue?vue&type=script&lang=js"
export * from "./Marzipano.vue?vue&type=script&lang=js"
import style0 from "./Marzipano.vue?vue&type=style&index=0&id=46d649da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d649da",
  null
  
)

export default component.exports